<button class="text-collapse-trigger" [class.active]="isTextVisible" (click)="toggleText()">
  {{ text }}
  <span class="text-collapse-trigger__icon">
    <app-ui-icon [name]="'icon-arrow-keyboard'" [width]="12" [height]="7"></app-ui-icon>
  </span>
</button>
<div *ngIf="isTextVisible" @slideToggle>
  <ng-content></ng-content>
</div>
